import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import {convertStringToElements }from "@vds/html-parsers";

import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import StyledLink from "common-components/StyledLink";
import Container from "common-components/Container";

class AuthorizedAgentSubmitSuccess extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("assign authorized agent success", this.props.pageContent.sc_pagetitle);
    }
  }

  render() {
    if (!this.props.pageContent) {
      return <Redirect to="/privacy/secure/your-data/authorized-agent/information" />;
    }
    const { section_title, richText, buttons } = this.props.pageContent;

    return (
      <Container>
        <Header style={{ maxWidth: "596px" }}>{section_title}</Header>
        <Div style={{ margin: "40px 0", maxWidth: "595px" }}>
          <h2>{convertStringToElements(richText[0].title)}</h2>
          <p>{convertStringToElements(richText[0].description)}</p>
        </Div>
        <StyledLink background={buttons[0].type} to="/privacy/secure/your-data" replace>
          {buttons[0].text}
        </StyledLink>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { assign_agent_success: pageContent } }) => ({
  pageContent
});

export default connect(
  mapStateToProps,
  { setA11yContent }
)(AuthorizedAgentSubmitSuccess);

const Div = styled.div`
  h2 {
    font-size: 20px;
    line-height: 19px;
    margin-bottom: 12px;
  }
`;
